import { JsonEditor } from "json-edit-react";
import { useBuilderWatch } from "../form/form";

export function JSONPreviewTab() {
  const formStructure = useBuilderWatch("formStructure");

  return (
    <JsonEditor
      maxWidth="100%"
      restrictEdit={true}
      restrictAdd={true}
      restrictDelete={true}
      collapse={2}
      data={formStructure}
    />
  );
}
